import type { ReactElement } from 'react';
import { useServices, useT } from '../../../app/di';
import { useResource } from '../../../shared/hooks';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Card } from '../../../ui-kit/Card/Card';
import { Loading } from '../../../ui-kit/Loading/Loading';
import { useBlog } from '../../accounts/workspaces';
import { ReadinessList } from './ReadinessList/ReadinessList';

// POST-UC-7
export function ReadinessPanel({ postId, revision }: { postId: string; revision: number }): ReactElement {
  const { api } = useServices();
  const { t, te } = useT();
  const { blog } = useBlog();
  const readiness = useResource(() => api.posts.readiness(blog.id, postId), [api, blog.id, postId, revision]);
  return (
    <Card title={t('posts.readiness.title')}>
      {readiness.loading && !readiness.data ? (
        <Loading label={t('common.loading')} />
      ) : readiness.error ? (
        <Alert tone="danger">{te(readiness.error)}</Alert>
      ) : (
        <ReadinessList reports={readiness.data?.channels ?? []} />
      )}
    </Card>
  );
}
